import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  ConfigProvider,
  Flex,
  Card,
  Space,
  Image,
  Button,
  Spin,
} from "antd";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, LoadingOutlined } from "@ant-design/icons";
import { setModuleClicked } from "../../../redux/features/main/searchSlice";
import { WarningFilled } from "@ant-design/icons";

import defaultImage from "../../../assets/images/png/general/img_thumb_default.png";

import useActions from "./hooks/useActions";

// for translate
import { useTranslation } from "react-i18next";

import {
  colorTextTitle,
  ColorSecondary,
  ColorPrimary,
  textTitleMyLearningJourney,
  backgroundCard,
  textDescMyLearningJourney,
  badgeDaysLeftBackground,
  badgeNewBackground,
  colorTextTitleMobile,
  colorTextDesc
} from "../../../config/constant/color/index";

import SearchMobileLearningJourney from "../../main/contents/LearningJourney/lib/SearchMobileLearningJourney";

const CategoryAll = (props) => {
  const { t, i18n } = useTranslation();
  const searchBarPosition = useSelector(
    (state) => state.search.searchBarPosition,
  );
  const dispatch = useDispatch();
  const isMobileVersion = props?.isMobileVersion;
  const { isContentLibraryPage } = props;

  let [searchParams, setSearchParams] = useSearchParams();
  const [typeCategory, setTypeCategory] = useState("");

  //for mobile version
  let lengthData = searchParams.get("length");
  let getType = searchParams.get("all");
  const getSearch = searchParams.get("search");

  const { dataCategoryAll, reachEnd, reachBottom } = useActions();

  const cardStyle = {
    margin: 0,
    maxWidth: "228px",
    lineHeight: "normal",
    textAlign: "left",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    width: "228px",
  };

  const linkHref = (item) => {
    console.log("searchBarPosition", searchBarPosition);
    if (
      searchParams.get("all") !== undefined &&
      searchParams.get("all") !== "" &&
      searchParams.get("all") !== null
    ) {
      if (searchBarPosition === "search_mylj") {
        if (searchParams.get("all") === "program")
          return `/my-learning-journey/journey/${item.id}`;
        if (searchParams.get("all") === "course")
          return `/my-learning-journey/journey/${item.journey_id}/course/${item.id}`;
        if (searchParams.get("all") === "module") {
          if (item.module_type === 1) {
            // essential
            return `/my-learning-journey/journey/${item.journey_id}/course/${item.course_id}/module/${item.id}`;
          } else {
            // support
            return `/my-learning-journey/journey/${item.journey_id}/course/${item.course_id}/supporting/${item.id}`;
          }
        }
      } else {
        if (searchParams.get("all") === "academy")
          return `/content-library/academy/${item.id}`;
        if (searchParams.get("all") === "program")
          return `/content-library/academy/${item.academy_id}/journey/${item.id}`;
        if (searchParams.get("all") === "course")
          return `/content-library/academy/${item.academy_id}/journey/${item.journey_id}/course/${item.id}`;
        if (searchParams.get("all") === "module") {
          if (item.module_type === 1) {
            // essential
            return `/content-library/academy/${item.academy_id}/journey/${item.journey_id}/course/${item.course_id}/module/${item.id}`;
          } else {
            // support
            return `/content-library/academy/:${item.academy_id}/journey/${item.journey_id}/course/${item.course_id}/supporting/${item.id}`;
          }
        }
      }
    }
  };

  useEffect(() => {
    if (
      searchParams.get("all") !== undefined &&
      searchParams.get("all") !== "" &&
      searchParams.get("all") !== null
    ) {
      if (searchParams.get("all") === "academy") setTypeCategory("Academy");
      if (searchParams.get("all") === "program")
        setTypeCategory(t("feature.feature_search.program"));
      if (searchParams.get("all") === "course")
        setTypeCategory(t("feature.feature_search.course"));
      if (searchParams.get("all") === "module")
        setTypeCategory(t("feature.feature_search.module"));
    }
  }, [searchParams]);

  const renderCardMobile = (item, id, index, name) => {
    const cardContent = (
      <Card
        key={index}
        data-id={index}
        style={{
          padding: 0,
          boxShadow: "3px 0 16px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          width: "100%",
        }}
        className="card-search-mobile"
      >
        <Row
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            textAlign: "left",
          }}
        >
          <Space
            direction={"horizontal"}
            style={{ borderRadius: "0", width: "100%", gap: "0px" }}
            className="space-learning-journey"
          >
            <div style={{ width: "100%", height: "91px" }}>
              <div
                style={{
                  display:
                    item?.days_left && item?.is_completed !== 1
                      ? "block"
                      : "none",
                }}
              >
                <div
                  style={{
                    zIndex: 1,
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    background: badgeDaysLeftBackground,
                    position: "absolute",
                    left: 0,
                    top: 0,
                    fontSize: "10px",
                    padding: "4px 8px",
                    borderTopLeftRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                >
                  <WarningFilled style={{ color: "#FFFFFF" }} />
                  &nbsp;
                  {item?.days_left ? (
                    item?.days_left !== "overdue" ? (
                      item?.days_left > 1 ? (
                        <>
                          {item?.days_left}{" "}
                          {t("feature.feature_mylj.anchor.days_left")}
                        </>
                      ) : (
                        <>{item?.days_left} Day left</>
                      )
                    ) : (
                      <>{t("feature.feature_mylj.anchor.overdue")}</>
                    )
                  ) : null}
                </div>
              </div>
              <Image
                preview={false}
                width={"108.95px"}
                height={"91px"}
                style={{
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
                src={item.thumbnail}
                fallback={defaultImage}
                alt="My learning journey Mobile on View All"
              />
              <div style={{ display: item?.badge_new ? "block" : "none" }}>
                <div
                  style={{
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    background: badgeNewBackground,
                    position: "absolute",
                    right: 0,
                    top: 0,
                    fontSize: "10px",
                    padding: "4px 8px",
                    borderTopRightRadius: "8px",
                    borderBottomLeftRadius: "8px",
                  }}
                >
                  {t("feature.feature_mylj.anchor.new")}
                </div>
              </div>
            </div>
            <Space
              direction="vertical"
              style={{
                width: "100%",
                padding: "10px 12px 0 12px",
                gap: "4px",
              }}
            >
              <div
                className="title-program"
                style={{
                  height: "32px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: textTitleMyLearningJourney,
                  textAlign: "left",
                }}
              >
                <div
                  className={
                    isMobileVersion
                      ? "break-dots-second-line"
                      : "center-vertically-and-horizontally break-dots-second-line"
                  }
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    lineHeight: "normal",
                    width: "100%",
                  }}
                >
                  {item.name}
                </div>
              </div>
              <div
                className="desc-program break-dots-second-line"
                style={{
                  fontSize: "12px",
                  height: "32px",
                  lineHeight: "1.4",
                  color: textDescMyLearningJourney,
                  textAlign: "left",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: isMobileVersion ? "100%" : "200px",
                }}
              >
                {item.description}
              </div>
              {/* <div>
                <Row
                  direction="horizontal"
                  style={{
                    marginBottom: 0,
                  }}
                >
                  <Col span={12}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                      }}
                    >
                      <Image
                        preview={false}
                        width={16}
                        src={i_courses}
                        alt="icon courses"
                      />
                      <span
                        style={{
                          marginLeft: "5px",
                          fontSize: "12px",
                          fontWeight: "500",
                          color: textTitleMyLearningJourney,
                        }}
                      >
                        {countTotalCourse(id) > 1 ? (
                          <>
                            {countTotalCourse(id)}{" "}
                            {t("feature.feature_mylj.anchor.courses")}
                          </>
                        ) : (
                          <>
                            {countTotalCourse(id)}{" "}
                            {t("feature.feature_mylj.anchor.course")}
                          </>
                        )}
                      </span>
                    </div>
                  </Col>
                  <Col
                    span={12}
                    className="primary-bg-color"
                    style={{
                      display: "flex",
                      fontWeight: "500",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                      fontSize: "12px",
                    }}
                  >
                    {item?.is_new !== 1 && (
                      <span
                        style={{
                          color:
                            checkProgressCompleteCourse(id) === 0
                              ? ColorDisabled
                              : checkProgressCompletedColor(id),
                        }}
                      >
                        {checkProgressCompleteCourse(id)}%{" "}
                        {t("feature.feature_mylj.anchor.completed_label")}
                      </span>
                    )}
                  </Col>
                </Row>
              </div> */}
            </Space>
          </Space>
        </Row>
      </Card>
    );

    return (
      <Link
        to={linkHref(item)}
        data-index={index}
        key={index}
        style={{ width: "100%" }}
      >
        {cardContent}
      </Link>
    );
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Roboto",
        },
      }}
    >
      <div
        style={{
          textAlign: "left",
          padding: isMobileVersion
            ? "20px 18px"
            : !reachEnd
            ? "36px 40px 0"
            : "36px 40px 48px",
        }}
      >
        {!isMobileVersion && (
          <div
            style={{
              lineHeight: "normal",
              marginBottom: 31,
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              className="cursor-pointer"
              style={{ marginRight: 16 }}
              onClick={() =>
                setSearchParams({ search: searchParams.get("search") })
              }
            >
              <ArrowLeftOutlined
                className="arrow-back"
                style={{ color: colorTextTitle, fontSize: 18 }}
              />
            </div>
              <div
                style={{display:"flex",alignItems:"center", gap:7}}
              >
                <div
                  style={{ fontSize: 22, fontWeight: 500, color: colorTextTitle }}
                >
                  “{searchParams.get("search")}” {t("feature.feature_search.in")}{" "}
                  {typeCategory}
                </div> <span style={{
                    fontSize: 22,
                    color: colorTextDesc
                  }}>
                      ({lengthData} {t("feature.feature_search.found")})
                    </span>
            </div>
          </div>
        )}

        {isMobileVersion &&
          (isContentLibraryPage ? null : <SearchMobileLearningJourney />)}

        {isMobileVersion && (
          <div
            style={{
              fontSize: 20,
              lineHeight: "normal",
              marginBottom: dataCategoryAll.length > 0 ? 20 : 8,
              color: colorTextTitle,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <div
              style={{
                fontWeight: 400,
                fontSize: 16,
                color: colorTextTitleMobile,
              }}
            >
              <span
                style={{
                  fontWeight: 500,
                  fontSize: 16,
                  color: colorTextTitleMobile,
                  textTransform: "capitalize",
                }}
              >
                "{getSearch}" <span style={{ textTransform: "none" }}>in</span>{" "}
                {getType}
              </span>{" "}
              ({lengthData} {t("feature.feature_search.found")})
            </div>
          </div>
        )}

        <div>
          <div>
            <Flex
              className="h-100 w-100 flex-search-category"
              wrap="wrap"
              gap={isMobileVersion ? "16px" : "middle"}
            >
              {dataCategoryAll && dataCategoryAll.length > 0 ? (
                dataCategoryAll &&
                dataCategoryAll.map((itemCategoryAll, indexCategoryAll) =>
                  isMobileVersion ? (
                    renderCardMobile(
                      itemCategoryAll,
                      itemCategoryAll.id,
                      indexCategoryAll,
                      typeCategory.toLowerCase(),
                    )
                  ) : (
                    <Card
                      key={indexCategoryAll}
                      bordered={false}
                      data-id={itemCategoryAll.id}
                      bodyStyle={{
                        padding: 0,
                        boxShadow: "3px 0 16px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                      }}
                    >
                      <Row style={cardStyle}>
                        <Space
                          direction="vertical"
                          style={{ borderRadius: "0" }}
                        >
                          <div style={{ width: "100%", height: "150px" }}>
                            <Image
                              preview={false}
                              width={228}
                              height={156}
                              style={{
                                objectFit: "cover",
                                borderTopLeftRadius: "8px",
                                borderTopRightRadius: "8px",
                              }}
                              src={itemCategoryAll.thumbnail}
                              fallback={defaultImage}
                              alt="Thumbnail Program View All"
                            />
                          </div>
                          <Space
                            direction="vertical"
                            style={{
                              width: "100%",
                              padding: "10px 14px 14px 14px",
                            }}
                          >
                            <div
                              className="title-program"
                              style={{
                                height: "38px",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: textTitleMyLearningJourney,
                                textAlign: "left",
                              }}
                            >
                              <div
                                className={
                                  isMobileVersion
                                    ? "break-dots-second-line"
                                    : "center-vertically-and-horizontally break-dots-second-line"
                                }
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {itemCategoryAll.name}
                              </div>
                            </div>
                            <div
                              className="desc-program break-dots-second-line"
                              style={{
                                fontSize: "12px",
                                height: "32px",
                                lineHeight: "1.4",
                                color: textDescMyLearningJourney,
                                textAlign: "left",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "200px",
                                marginBottom: 12,
                              }}
                            >
                              {itemCategoryAll.description}
                            </div>
                            <div>
                              <Link
                                to={linkHref(itemCategoryAll)}
                                data-index={indexCategoryAll}
                                name={`btn-enter-${searchParams.get(
                                  "all",
                                )}-search`}
                                onClick={() => {
                                  if (searchParams.get("all") === "module") {
                                    dispatch(setModuleClicked(1));
                                  }
                                }}
                              >
                                <Button
                                  className={`btn-enter-${searchParams.get(
                                    "all",
                                  )}-search`}
                                  block
                                  style={{
                                    background: ColorPrimary,
                                    color: backgroundCard,
                                    borderColor: "unset",
                                    borderRadius: "8px",
                                    fontSize: "12px",
                                    height: "29px",
                                  }}
                                >
                                  {t("feature.feature_search.explore")}
                                </Button>
                              </Link>
                            </div>
                          </Space>
                        </Space>
                      </Row>
                    </Card>
                  ),
                )
              ) : (
                <></>
              )}
            </Flex>
          </div>
        </div>
      </div>
      <div
        className="loader-wrapper"
        style={{
          display: !reachEnd && reachBottom ? "flex" : "none",
          marginBottom: 40,
          marginTop: 40,
        }}
      >
        <div style={{ height: 32, margin: "auto", display: "flex" }}>
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 32,
                  color: ColorPrimary,
                }}
                spin
              />
            }
          />
        </div>
      </div>
    </ConfigProvider>
  );
};

export default CategoryAll;
